import * as Yup from "yup";

export const formValidator = () =>
	Yup.object({
		organisationCode: Yup.string().notRequired()
	});
